module.exports = __webpack_public_path__ + "img/bruce_springsteen.e8e46e30.jpg";